<template>
	<div class="container">
		<LoadingScreen v-if="this.show.loading" />
		<ModalAlert id="redefinir-senha-success" @close="$router.replace('/')">
			<DynamicIcon icon="check" :classString="'alert-exclamation'"/>
			Sua senha foi alterada com sucesso! <br /> Você será redirecionado para tela inicial.
		</ModalAlert>

		<ModalAlert id="redefinir-senha-invalid-token" @close="$router.replace('/')">
			<DynamicIcon icon="not" :classString="'alert-exclamation'"/>
			Token Inválido. <br /> Você será redirecionado para a tela inicial.
		</ModalAlert>
		<div class="row align-self-center justify-content-center initial-div-right-father">
			<div class="col-5" id="initial-img-left"></div>
			<div class="col-7" id="initial-div-right">
				<div id="initial-sub-div-right">
					<div id="logo">
						<img src="@/assets/optum-logo.svg"/>
					</div>

					<div id="indicators-initial">
						<img class="icon" src="@/assets/Icon_ArrowCircle.svg"/>
						<b>Alterar senha</b>
					</div>
					<div class="div-text animate__fadeInUp">
						<p class="my-4">
						Olá, <b>{{capitalizarPrimeiraLetraNomeCompleto(name)}}</b>! 
						<br/>Preencha os campos abaixo para redefinir sua senha.
						</p>
						<p class="my-4">Sua senha deve conter ao menos: 
						<ul>
							<li v-for="(item, index) in requirementsLabels" :key="index">
								<template v-if="requirements[index]"> <b-icon-check2 font-scale="1.5" variant="success" /></template>
								<template v-else> <b-icon-x font-scale="1.5" variant="danger" /></template> 
								{{ item }}
							</li>
						</ul>
						</p>
						<p class="my-4">Senha sugerida: {{suggestedPassword()}}</p>
					</div>
					<b-form class="mb-3 animate__fadeInUp">
						<InputConfirmPassword
							v-model="password"
							:validation-message="validation.password"
							id="password-1"
							placeholder="Digite a nova senha"
						/>
						<InputConfirmPassword
							v-model="confirmPassword"
							:validation-message="validation.confirmPassword"
							id="password-2"
							placeholder="Confirmar nova senha"
						/>
						<b-form-invalid-feedback :state="validationMessage ? false : true">
							{{validationMessage}}
						</b-form-invalid-feedback>

						<div class="group-btn mt-4">
							<b-button pill class="btn-base outline-primary-btn salvar" @click="back" >Cancelar</b-button>
							<b-button pill class="btn-base primary-btn salvar" @click="savePassword" >Salvar</b-button>
						</div>
					</b-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import InputConfirmPassword from "./components/InputConfirmPassword.vue"
import LoadingScreen from "@/components/commons/LoadingScreen.vue"
import ModalAlert from "../../commons/ModalAlert.vue"
import Validations from "@/util/Validations"
import UserResource from '@/resources/UserResource.js'
import generatorPassword from "generate-password"
import { mapActions } from "vuex"

export default {
	name: "EsqueciSenha",
	components: {
		InputConfirmPassword,
		LoadingScreen,
		ModalAlert,
		DynamicIcon
	},
	data() {
		return {
			password: null,
			confirmPassword: null,
			validation: {
				password: null,
				confirmPassword: null 
			},
			show: {
				loading: false
			},
			name: null,
			requirements: {
				length: false,
				number: false,
				lowerCase: false,
				upperCase: false,
				specialChar: false,
			},
			requirementsLabels:  {
				length: "dez caracteres",
				number: "um número",
				lowerCase: "uma letra minúscula",
				upperCase: "uma letra maiúscula",
				specialChar: "um caractere especial",
			}
		};
	},
	computed:{
		validationMessage(){
			if(this.validation.password) return this.validation.password
			if(this.validation.confirmPassword) return this.validation.confirmPassword

			return null
		}		
	},
	methods: {
		...mapActions("user", ["saveOuthTokens"]),
		savePassword() {

			this.validate()

			if (!Validations.isEmpty(this.validation)) {
				return
			}

			this.show.loading = true
			UserResource.redefinePassword(this.$route.params.token, this.password, {showLoader: true})
			.then(response => {
				this.saveOuthTokens({accessToken: response.access_token, refreshToken: response.refresh_token})
				.then(() => {
					this.$bvModal.show('redefinir-senha-success')
				})
			})
			.catch(response => this.validation.password = Validations.getHttpFieldMessage(response, "password"))
			.then( () => this.show.loading = false )

		},
		validate() {
			this.validation.confirmPassword = null
			this.validation.password = Validations.password(this.password)
			
			if (!this.confirmPassword) {
				this.validation.confirmPassword = "Este campo é obrigatório"
			}
			else if ( this.password != this.confirmPassword ) {
				this.validation.confirmPassword = "As senhas não conferem, favor revisar os campos"
			}
			else {
				this.validation.confirmPassword = ""
			}
		},
		checkPasswordRequirements(password) {
			return {
				length: password.length >= 10,
				number: /\d/.test(password),
				lowerCase: /[a-z]/.test(password),
				upperCase: /[A-Z]/.test(password),
				specialChar: /[^A-Za-z0-9]/.test(password),
			};
		},
		back() {			
			this.validation.error = null
			this.validation.cpf = null;
			this.$router.replace("/");
		},
		capitalizarPrimeiraLetraNomeCompleto(nomeCompleto) {
			if(!nomeCompleto) return ''
			// Divide o nome completo em palavras
			const palavras = nomeCompleto.split(' ');

			// Capitaliza a primeira letra de cada palavra
			const nomeCapitalizado = palavras.map(palavra => {
				// Verifica se a palavra não está vazia
				if (palavra.length > 0) {
				// Transforma a primeira letra da palavra em maiúscula e o restante em minúscula
				return palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();
				} else {
				return palavra; // Mantém palavras vazias inalteradas
				}
			});

			// Junta as palavras novamente em um único nome
			return nomeCapitalizado.join(' ');
		},
		suggestedPassword(){
			return ['A','c', '1','!',
					generatorPassword.generate({ length: 5, numbers: true, symbols: "@#$%^&+=!"}),
					generatorPassword.generate({ length: 5, numbers: true, symbols: "@#$%^&+=!"})
			]
			.map(value => ({ value, sort: Math.random() }))
			.sort((a, b) => a.sort - b.sort)
			.map(({ value }) => value)
			.join("");
		}
	},
	watch: {
        password: function(value) {
			this.requirements = this.checkPasswordRequirements(value)
        },
		confirmPassword: function(value) {
			this.requirements = this.checkPasswordRequirements(value)
        }
    },
	created(){
		UserResource.validateToken( this.$route.params.token, {showLoader: true})
		.then( response => this.name = response.name )
		.catch(res => {
			if(res.fieldErrors.token[0] == "inválido"){
				this.$bvModal.show('redsefinir-senha-invalid-token')
			}
		})
	}
}

</script>

<style scoped lang="scss">
html body button.salvar{
	font-size: 16px !important;
}

.icon {
  width: 32px;
  margin-right: 0 6% 0 0;
}
.div-text {
	text-align: initial;
	font-size: 15px;
	margin-bottom: 20px;
}

.div-text i {
	font-size: 12px;
}

.initial-div-right-father{
	background-color: $screenBgColor;
}

#initial-sub-div-right {
	width: 60%;
}
div.container {
	margin: 0px;
	max-width: 100vw;
}
#indicators-initial {
	display: flex;
	justify-content: flex-start;
	align-items:flex-start;
	gap: 15px;
	margin-bottom: 10px;
}

#indicators-initial b {
	border-bottom: #002677 solid 3px;
	color: #002677 !important;
	width:105px;
}

#input-CPFCNPJ label {
	text-align: justify !important;
}

.group-btn {
	display: flex;
	justify-content: flex-end;
	gap:10px;
}

.b-icon-check-circle {
	color: #627d32;
	width: 3em;
	height: 3em;
    margin-bottom: 10px;
}

.b-icon-x{
	color: #922c2c;
	width: 3em;
	height: 3em;
    margin-bottom: 15px;
}

@media (max-width: 1080px) {
	#initial-sub-div-right {
		width: 300px !important;
	}

	.div-text {
		width: 300px;
	}
}

@media (max-width: 930px) {
	.group-btn {
		justify-content: space-between;
	}

	.group-btn button {
		width: 100% !important;
	}
}
</style>